<template>
  <app-cell class="email-transaction-cell" :editable="false">
    <base-stack>
      <h3>
        {{ name }}
      </h3>
      <base-stack>
        <div v-for="event in events" :key="event.id" class="event-item">
          <span class="event-type" :class="event.class">{{ event.type }}</span>
          <span class="event-time">{{ event.timestamp | dayjs('MMM DD, YYYY (HH:mm:ss)') }}</span>
        </div>
      </base-stack>
    </base-stack>
  </app-cell>
</template>

<script lang="ts">
import AppCell from '@/components/Cell.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EmailCategory, EmailRecipient } from '../types/api';

@Component({
  components: { AppCell },
})
export default class EmailTransactionCell extends Vue {
  @Prop({ type: Object, required: true }) public email!: EmailRecipient;

  get name() {
    switch (this.email.email.category) {
      case EmailCategory.Order:
        return 'Order confirmation';
      case EmailCategory.Reset:
        return 'Password reset';
    }
    return this.email.email.category.split(/(?=[A-Z])/).join(' ');
  }

  get events() {
    const sentEvent = {
      id: 'sent',
      type: 'Sent',
      timestamp: this.email.email.createdAt,
    };

    const events = this.email.events ? [...this.email.events] : [];
    return [...events.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()), sentEvent].map(
      (event) => ({
        ...event,
        class: `event-${event.type.toLowerCase().replace(/[^a-z0-9]/g, '-')}`,
      })
    );
  }
}
</script>

<style lang="scss" scoped>
.event-item {
  display: flex;
  justify-content: space-between;

  .event-type {
    padding: 0.125rem 0.375rem;
    border-radius: 3px;
    font-size: 0.7rem;
    font-weight: 500;
    text-transform: uppercase;
    background-color: rgba($color-theme-yellow, 0.1);
    color: $color-theme-yellow;

    &.event-delivered {
      background-color: rgba($color-success, 0.1);
      color: $color-success;
    }

    &.event-bounced,
    &.event-bounce {
      background-color: rgba($color-theme-red, 0.1);
      color: $color-theme-red;
    }
  }

  .event-time {
    font-size: 0.75rem;
    color: $color-disabled;
  }
}
</style>
